// Lib
import { useSelector } from 'react-redux';

// Hooks
import useBodyClass from '../../utils/react/useBodyClass';

// Selectors
import {
    getApplicationTypeSelector,
    getBrowserEngineSelector,
    getIsTouchSelector,
    getMilanoteApplicationModeSelector,
    getPlatformFormFactorSelector,
    getPlatformTypeSelector,
} from '../platformSelector';
import { selectIsMobileLandscapeModeActive } from '../screenOrientation/mobileScreenOrientationSelector';

/**
 * This hook is responsible for adding platform related classes
 * to the body element (e.g. 'browser-engine-chrome', 'platform-ios' etc).
 */
export default function usePlatformBodyClassManager() {
    const browserEngine = useSelector(getBrowserEngineSelector);
    useBodyClass(`browser-engine-${browserEngine}`);

    const platform = useSelector(getPlatformTypeSelector);
    useBodyClass(`platform-${platform}`);

    const formFactor = useSelector(getPlatformFormFactorSelector);
    useBodyClass(`form-factor-${formFactor}`);

    const applicationType = useSelector(getApplicationTypeSelector);
    useBodyClass(`application-type-${applicationType}`);

    const isTouch = useSelector(getIsTouchSelector);
    useBodyClass(isTouch ? 'touch-device' : 'not-touch-device');

    const applicationMode = useSelector(getMilanoteApplicationModeSelector);
    useBodyClass(`app-mode-${applicationMode}`);

    // Drives MobileWorkspaceLandscape.scss, which cannot use an orientation media query: a landscape-shaped
    // window is only a phone held sideways when it fills the screen
    const isMobileLandscapeModeActive = useSelector(selectIsMobileLandscapeModeActive);
    useBodyClass(isMobileLandscapeModeActive ? 'mobile-landscape-mode' : '');
}
